import { OrgEntity } from "@swivl-mono/entities";
import { OrgInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Org/Org.Controller.ts
export class OrgsAPI {
  static async getOrg(orgId: number) {
    return APIService.Server.get<OrgInterface>(`/org/${orgId}`);
  }
  static async getAllOrgs() {
    return APIService.Server.get<OrgInterface[]>(`/org/all`);
  }
  static async avatarsForOrgs(orgIds: string) {
    return APIService.Server.get<{ [orgId: number]: string }>(`/org/avatars`, { orgIds });
  }
  static async createOrg(org: Partial<OrgInterface>) {
    return APIService.Server.post<OrgInterface>(`/org`, org);
  }
  // static async getParentId(orgId: number | OrgInterface) {
  //     return APIService.Server.get<number>(`/org/${orgId}/parent-id`);
  // }
}
